/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { Table, FlexboxGrid } from 'rsuite';
import { toast } from 'react-toastify';
import { Container } from '~/styles/tabela';
import api from '~/services/api';
import {
  CelulaEditavel,
  CelulaAcao,
} from '~/components/Celulas/components/CelulaEditavel';
import { TabelaSemPaginacao } from '~/components/TabelaSemPaginacao';
import Card from '../../../components/Card';
import PageHeader from '../../../components/PageHeader';

const { HeaderCell, Column } = Table;

function ConfiguracoesRecrutamento() {
  const [dados, setDados] = useState({
    configuracosLista: [],
    configuracosListaFiltrada: [],
    listaInicial: [],
  });
  const [dadosInicial, setDadosInicial] = useState();
  const [carregando, setCarregando] = useState(true);

  async function buscarConfiguracoes() {
    const resposta = await api.get('configuracoes');
    const resposta1 = await api.get('configuracoes');
    setDados({
      configuracosLista: resposta.data,
      configuracosListaFiltrada: resposta.data,
      listaInicial: resposta1.data,
    })
    setCarregando(false);
  }

  useEffect(() => {
    buscarConfiguracoes();
  }, []);

  function alterarTextoCelula(id, key, value) {
    const nextData = Object.assign([], dados.configuracosLista);
    nextData.find((item) => item.id === id)[key] = value;
    setDados({ ...dados, configuracosLista: nextData });
  }

  async function alterarEstadoCelula(id) {
    const novaLista = Object.assign([], dados.configuracosLista);
    const item = novaLista.find((config) => config.id === id);
    const itemIncial = dados.listaInicial.find((config) => config.id === id);

    if (item.status === 'EDIT' && item.whatsapp !== itemIncial.whatsapp) {
      try {
        setCarregando(true);
        await api.put(`configuracoes/${id}`, item);
        toast.success('Configurações atualizado com sucesso');
        buscarConfiguracoes();
      } catch (error) {
        toast.error(error.message);
      }
      setCarregando(false);
    } else {
      item.status = item.status ? null : 'EDIT';
      setDados({ ...dados, configuracosLista: novaLista });
    }
  }

  return (
    <Container>
      <PageHeader
        title="Configurações Recrutamento"
        subtitle="Gerencie as configurações do Recrutamento"
      // actions={
      //   <Button
      //     appearance="primary"
      //     startIcon={<Plus />}
      //     onClick={() => setAdicionarIdiomaDialog(true)}
      //   >
      //     Novo Idioma
      //   </Button>
      // }
      />
      <Card>
        <TabelaSemPaginacao
          carregando={carregando}
          dados={dados.configuracosLista}
        >
          <Column resizable width={200}>
            <HeaderCell>Ações</HeaderCell>
            <CelulaAcao
              dataKey="id"
              onClick={alterarEstadoCelula}
            />
          </Column>
          <Column resizable width={240} sortable>
            <HeaderCell>Telefone</HeaderCell>
            <CelulaEditavel dataKey="whatsapp" onChange={alterarTextoCelula} />
          </Column>

        </TabelaSemPaginacao>
      </Card>

    </Container>
  );
}

export default ConfiguracoesRecrutamento;
